import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type PermissionCodes = 'DISPLAY_PATHS' | 'DISPLAY_TRAINING_PLANS';

const useTrainingPermissions = getPermissionsHook<PermissionCodes, 'userTrainingPermissions'>({
  entityName: 'userTrainingPermissions',
  fetch: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).trainingPermissions.get(),
});

export default useTrainingPermissions;
